import initSubscribeForm from '~scripts/blocks/subscribe-form';

// Core
import { isInViewport } from '~scripts/core/helpers';
import { VKVideoPlayer } from '~scripts/core/VKVideoPlayer';

const videoPlayer = document.getElementById('eventVideo');
const subscribeForm = document.querySelector('.event-video #subscribeForm');
const videoFormWrapper = document.querySelector('.js-event-video__form');
const storage = window.localStorage;
const formExist = !!videoFormWrapper;

if (formExist) {
  initSubscribeForm(subscribeForm);
}

const handleWindowScroll = (button, playersList) => {
  if (!isInViewport(button)) {
    if (button.classList.contains('event-video__thumb--hidden')) {
      button.classList.remove('event-video__thumb--hidden');
      videoPlayer.classList.remove('event-video__player--visible');
      playersList['player-0'].pause();
    }
  }
};

const handlePlayButtonClick = (button, playersList) => {
  button.classList.add('event-video__thumb--hidden');

  if (storage.getItem('videoFormSubmitted') || !formExist) {
    videoPlayer.classList.add('event-video__player--visible');
    try {
      playersList['player-0'].play();
    } catch {
      console.warn('Video player is not ready');
    }
  } else {
    videoFormWrapper.classList.add('event-video__form--visible');
    subscribeForm.querySelector('input[name="name"]').focus();
  }
};

const handleFormSend = (e, playersList) => {
  const formType = e.target.dataset.type;

  if (formType === 'event_subscribe') {
    storage.setItem('videoFormSubmitted', '1');
    videoFormWrapper.classList.remove('event-video__form--visible');
    videoPlayer.classList.add('event-video__player--visible');
    playersList['player-0'].play();
  }
};

const playerOptions = {
  videoElements: '.js-video',
  playButtonSelector: '.js-play-video',
  handlePlayButtonClick: handlePlayButtonClick,
  handleWindowScroll: handleWindowScroll,
  handleFormSend: handleFormSend,
};

const eventVideo = document.getElementById('eventVideo');
if (eventVideo?.querySelector('.js-vk-video')) {
  const player = await new VKVideoPlayer(playerOptions);
  player.init();
}
